import { useStyleConfig } from "@chakra-ui/react";
import { InlineModalButtonFragment } from "src/__generated__/cms-schema.codegen";
import { resolveTenantAware } from "src/lib/emilTenantMaps";
import { useProduct } from "src/lib/hooks";
import { CMSButtonLabel } from "./CMSButtonLabel";
import { PremiumCalcButton } from "../PremiumCalcModal/PremiumCalcButton";
import { URLModalButton } from "../URLModal/URLModalButton";
import { ModalRoutes } from "../URLModal/modalRoutes";

export type CMSModalButtonProps = InlineModalButtonFragment & {
	inHeader?: boolean;
};

export const CMSModalButton: React.FC<CMSModalButtonProps> = ({
	modalName,
	analyticsId,
	linkStyle,
	leftIcon,
	rightIcon,
	label,
	enablePrefill,
	inHeader,
	product,
}) => {
	const sx = useStyleConfig("CMSButton", {
		variant: linkStyle,
		inHeader,
	});

	const common = {
		variant: linkStyle,
		sx,
		"data-testid": "cms-modal-button",
	};

	const productCtx = useProduct();

	const hasCategory = Boolean(
		product?.productCategory ?? productCtx?.productCategory,
	);
	const productOrCategory = hasCategory
		? (product?.productCategory?.slug ?? productCtx?.productCategory?.slug)
		: (product?.slug ?? productCtx?.slug);
	const categoryProduct = hasCategory
		? (product?.slug ?? productCtx?.slug)
		: undefined;

	if (modalName === "PremiumCalc") {
		return (
			<PremiumCalcButton
				id={analyticsId}
				productOrCategory={productOrCategory}
				categoryProduct={categoryProduct}
				enablePrefill={enablePrefill ?? false}
				{...common}
			>
				<CMSButtonLabel
					leftIcon={leftIcon?.name}
					rightIcon={rightIcon?.name}
					label={label}
				/>
			</PremiumCalcButton>
		);
	}

	return (
		<URLModalButton
			id={analyticsId}
			modalName={modalName as keyof ModalRoutes}
			params={{
				...(modalName === "CreateClaim" && {
					productCode: product?.currentVersion?.productCode
						? resolveTenantAware(product.currentVersion.productCode)
						: undefined,
				}),
			}}
			{...common}
		>
			<CMSButtonLabel
				leftIcon={leftIcon?.name}
				rightIcon={rightIcon?.name}
				label={label}
			/>
		</URLModalButton>
	);
};

// 🔬 RTL
